import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../assests/lottie/whatsapp.json'; // ensure correct path

const WhatsAppButton = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <a
      href="https://wa.me/919994426564" // replace with your WhatsApp number
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-3 right-3 md:bottom-6 md:right-6 z-50 rounded-full transition-transform duration-300 hover:scale-105 active:scale-95 max-w-[100vw] max-h-[100vh]"
    >
      <div className="w-12 h-12 md:w-16 md:h-16">
        <Lottie options={defaultOptions} height={"100%"} width={"100%"} style={{ width: '100%', height: '100%' }} />
      </div>
    </a>
  );
};

export default WhatsAppButton;
